var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(!_vm.withoutLabel)?_c('p',[_c('b',[_vm._v(_vm._s(_vm.data.label)+": ")])]):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.data.displayValue))])])
}
var staticRenderFns = []

export { render, staticRenderFns }